export const searchMixin = {
  methods: {
    query: function(q) {
      console.log(`query: ${q}`)
      q = q.toUpperCase()
      if (/^[A-Z][0-9][0-9][0-9]$/.test(q)) {
        this.$emit('submit', {
          type: 'shelfSpace',
          shelfId: q.substr(0, 2),
          spaceId: q.substr(2, 2)
        })
      } else if (/W[0-9]-[0-9][0-9]/.test(q)) {
        this.$emit('submit', {
          type: 'boxSpace',
          boxId: q
        })
      } else if (/A[0-9][0-9][0-9][0-9]/.test(q)) {
        this.$emit('submit', {
          type: 'product',
          productId: q
        })
      } else {
        const product = _.find(this.$store.state.products, { eans: [{ ean: q }] })
        this.$emit('submit', {
          type: 'product',
          productId: product.id
        })
      }
    }
  }
}
